module.exports = __webpack_public_path__ + "static/media/georgiai.aaf84cf4.woff";